module.exports = __webpack_public_path__ + "static/img/user.c7399c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/user.png
// module id = U/Ox
// module chunks = 3